import { useMemo } from 'react';

import { bonusTypes } from 'common/constants';

const { DEPOSIT, DEPOSIT_FREESPIN, FREESPIN, NO_DEPOSIT, RELOAD_DEPOSIT, RELOAD_NO_DEPOSIT } =
  bonusTypes;

const DEPOSIT_LIKE_TYPES = new Set([NO_DEPOSIT, DEPOSIT, RELOAD_DEPOSIT, RELOAD_NO_DEPOSIT]);

const FREESPIN_LIKE_TYPES = new Set([FREESPIN, DEPOSIT_FREESPIN]);

const hasValue = value => (Number(value) || 0) > 0;

export const resolveBonusCancelType = bonus =>
  bonus?.type ?? bonus?.bonusType ?? bonus?.bonus?.bonusType ?? bonus?.bonus?.type;

const useBonusCancelDetails = (bonus, wallet) => {
  const { BONUS = 0, CASH = 0, FROZEN = 0 } = wallet?.detailedBalance || {};
  const bonusType = resolveBonusCancelType(bonus);
  const { requiredWagering = 0, wagering = 0 } = bonus || {};

  const cash = Number(CASH) || 0;
  const lockedCash = Number(FROZEN) || 0;
  const keepCash = cash + lockedCash;
  const bonusAmount = Number(BONUS) || 0;
  const bonusWinnings = 0;
  const wageringLeft = Math.max(0, (Number(requiredWagering) || 0) - (Number(wagering) || 0));
  const freeSpins = bonus?.activeSpins ?? 0;
  const forfeit = bonusAmount;

  const showDepositRows = DEPOSIT_LIKE_TYPES.has(bonusType);
  const showFreespinRows = FREESPIN_LIKE_TYPES.has(bonusType);

  return useMemo(
    () => ({
      after: {
        forfeit: showDepositRows && hasValue(forfeit),
        freeSpinsRemoved: showFreespinRows && hasValue(freeSpins),
        keepCash: (showDepositRows || showFreespinRows) && hasValue(keepCash),
        wageringReset: showDepositRows && hasValue(wageringLeft),
      },
      before: {
        bonus: showDepositRows && hasValue(bonusAmount),
        bonusWinnings: showDepositRows && hasValue(bonusWinnings),
        cash: (showDepositRows || showFreespinRows) && hasValue(cash),
        freeSpins: showFreespinRows && hasValue(freeSpins),
        lockedCash: showDepositRows && hasValue(lockedCash),
        wageringLeft: showDepositRows && hasValue(wageringLeft),
      },
      currency: wallet?.currency ?? '',
      values: {
        bonus: bonusAmount,
        bonusWinnings,
        cash,
        forfeit,
        freeSpins,
        keepCash,
        lockedCash,
        wageringLeft,
      },
    }),
    [
      bonusAmount,
      bonusWinnings,
      cash,
      forfeit,
      freeSpins,
      keepCash,
      lockedCash,
      showDepositRows,
      showFreespinRows,
      wageringLeft,
      wallet,
    ],
  );
};

export default useBonusCancelDetails;
